<template>
  <hic-list-page title="床位" :entities="entities" :condition.sync="condition" @load="page" :loading="meta.loading" keyword-placeholder="床位号或住院号" @export="download" show-model-switch :card-model="meta.showCard" @cardModelChange="modelChange" hide-search-dialog>
    <template #buttons>
      <el-button type="primary" size="small" icon="el-icon-document-add" @click="create">新建</el-button>
      <span class="info left-pad">拖动或点击患者调整床位</span>
    </template>
    <template #search>
      <el-cascader v-model="site" :options="options" :props="{ expandTrigger: 'hover', value: 'code', label: 'text', checkStrictly: true }" @change="siteChange" size="small" style="width: 18rem" placeholder="病房位置" clearable></el-cascader>
    </template>
    <el-table-column align="center" label="操作" width="100" key="iousCmd">
      <template slot-scope="{ row }">
        <el-button type="primary" title="编辑" size="mini" plain icon="el-icon-edit" circle @click="edit(row)"></el-button>
        <el-popconfirm title="确定要删除床位吗？" class="left-pad" @confirm="del(row)">
          <el-button slot="reference" type="danger" title="删除" size="mini" plain icon="el-icon-delete" circle :disabled="!!row.ipNo"></el-button>
        </el-popconfirm>
      </template>
    </el-table-column>
    <el-table-column align="left" label="床位号" prop="no">
      <template slot-scope="{ row }">
        <span class="bold-title">{{ row.no }}</span>
      </template>
    </el-table-column>
    <el-table-column align="center" label="病区" prop="wardCode" :filters="dict.IpWard" :filter-multiple="false" column-key="wardCode">
      <template slot-scope="{ row }">
        <div>{{ row.wardCode | dictText("IpWard") }}</div>
      </template>
    </el-table-column>
    <el-table-column align="right" label="楼栋" prop="building" :filters="dict.Building" :filter-multiple="false" column-key="building">
      <template slot-scope="{ row }">
        <div>{{ row.building | dictText("Building") }}</div>
      </template>
    </el-table-column>
    <el-table-column align="right" label="楼层" prop="floor" :filters="dict.Floor.filter((d) => !condition.building || !condition.building.length || d.parentCode === condition.building[0])" :filter-multiple="false" column-key="floor">
      <template slot-scope="{ row }">
        <div>{{ row.floor | dictText("Floor") }}</div>
      </template>
    </el-table-column>
    <el-table-column align="right" label="病房" prop="room" :filters="dict.Room.filter((d) => !condition.floor || !condition.floor.length || d.parentCode === condition.floor[0])" :filter-multiple="false" column-key="room">
      <template slot-scope="{ row }">
        <div>{{ row.room | dictText("Room") }}</div>
      </template>
    </el-table-column>
    <el-table-column align="center" label="类型" prop="type" width="100" :filters="dict.BedType" :filter-multiple="false" column-key="type">
      <template slot-scope="{ row }">
        <div>{{ row.type | dictText("BedType") }}</div>
      </template>
    </el-table-column>
    <el-table-column align="center" label="加床" prop="ifExtra" width="80" :filters="$utils.Dict.bool()" :filter-multiple="false" column-key="ifExtra">
      <template slot-scope="{ row }">
        <el-tag v-if="row.ifExtra" type="success" size="mini" hit>是</el-tag>
      </template>
    </el-table-column>
    <el-table-column align="center" label="停用" prop="disabled" width="80" :filters="$utils.Dict.bool()" :filter-multiple="false" column-key="disabled">
      <template slot-scope="{ row }">
        <el-tag v-if="row.disabled" type="danger" size="mini" hit>是</el-tag>
      </template>
    </el-table-column>
    <el-table-column align="left" label="患者" prop="ipNo">
      <template slot-scope="{ row }">
        <div
          v-if="row.hospitalization"
          @click="openBed(row)"
          @dragstart="dragstart($event, row.hospitalization)"
          @dragover="dragover($event)"
          @drop="drop($event, row)"
          draggable
          style="font-size: small; color: #409eff; background-color: #ecf5ff; border: 1px solid #409eff; border-radius: 5px; cursor: pointer; padding: 0 5px"
        >
          <i class="el-icon-user-solid" /> {{ row.hospitalization.patientName }} {{ row.hospitalization.patientGender | dictText("Gender") }} {{ row.hospitalization.patientAge }}
          {{ row.hospitalization.ipNo }}
        </div>
        <div v-else @dragover="dragover($event)" @drop="drop($event, row)" style="width: 100%; height: 16px"></div>
      </template>
    </el-table-column>
    <template slot="card" slot-scope="{ row }">
      <el-card class="top-pad" shadow="hover">
        <el-row slot="header" type="flex" justify="space-between" align="middle">
          <el-row>
            <b>{{ row.no }}床</b>
            <el-tag size="mini" hit type="primary" class="left-pad">{{ row.type | dictText("BedType") }}</el-tag>
            <el-tag v-if="row.disabled" size="mini" hit type="danger" class="left-pad" effect="dark">停</el-tag>
            <el-tag v-if="row.ifExtra" size="mini" hit type="warning" class="left-pad" effect="dark">加</el-tag>
          </el-row>
          <el-row>
            <el-button type="primary" title="编辑" size="mini" plain icon="el-icon-edit" circle @click="edit(row)" class="left-pad"></el-button>
            <el-popconfirm title="确定要删除床位吗？" class="left-pad" @confirm="del(row)">
              <el-button slot="reference" type="danger" title="删除" size="mini" plain icon="el-icon-delete" circle :disabled="!!row.ipNo"></el-button>
            </el-popconfirm>
          </el-row>
        </el-row>
        <el-descriptions :column="2">
          <el-descriptions-item label="病区">{{ row.wardCode | dictText("IpWard") }}</el-descriptions-item>
          <el-descriptions-item label="科室">{{ row.deptCode | dictText("Dept") }}</el-descriptions-item>
          <el-descriptions-item v-if="!setting.isSimple" label="位置" :span="2">{{ row.building | dictText("Building") }}{{ row.floor | dictText("Floor") }}{{ row.room | dictText("Room") }}</el-descriptions-item>
          <el-descriptions-item label="患者" :span="2" :contentStyle="{ height: '20px' }">
            <el-row v-if="row.hospitalization" type="flex" align="middle" justify="space-between">
              <div @click="openBed(row)" @dragstart="dragstart($event, row)" @dragover="dragover($event)" @drop="drop($event, row)" draggable style="font-size: small; color: #409eff; background-color: #ecf5ff; border: 1px solid #409eff; border-radius: 5px; cursor: pointer; padding: 0 5px">
                <i :class="row.id == row.hospitalization.bedId ? 'el-icon-user-solid' : 'el-icon-user'" :title="row.id == row.hospitalization.bedId ? '主床' : '包床'" />{{ row.hospitalization.patientName }} {{ row.hospitalization.patientGender | dictText("Gender") }}
                <span :title="row.hospitalization.diagnosisName">{{ row.hospitalization.patientAge }} {{ row.hospitalization.ipNo }}</span>
              </div>
              <span :class="row.hospitalization.ipType == '自费' ? 'left-pad warning' : 'left-pad success'">{{ row.hospitalization.ipType }}</span>
            </el-row>
            <div v-else @dragover="dragover($event)" @drop="drop($event, row)" style="width: 100%; height: 20px; border: 1px dashed #d9d9d9; border-radius: 5px; cursor: pointer; padding: 0 5px"></div>
          </el-descriptions-item>
        </el-descriptions>
      </el-card>
    </template>
    <Editor v-model="entity" :visible.sync="meta.showEditor" @saved="page"></Editor>

    <hic-hospitalization-beds-dialog :visible.sync="meta.showBed" :hospitalization="hospitalization" :hide-wrap="setting.isSimple" />

  </hic-list-page>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    // beforeRouteEnter (to, from, next) {
    //   // 在渲染该组件的对应路由被 confirm 前调用
    //   // 不！能！获取组件实例 `this`
    //   // 因为当守卫执行前，组件实例还没被创建
    //   if (!store.getters.permission.infusion_site_query) {
    //     next({
    //         name: 'err',
    //         params: { err: cfg.errs.NeedPromission }
    //     })
    //   } else {
    //     next()
    //   }
    // },
    beforeRouteLeave(to, from, next) {
      return next();
    },
    components: {
      Editor: () => import("./editor"),
    },
    data() {
      return {
        meta: {
          showCard: true,
          showBed: false,
          showEditor: false,
          loading: false,
        },
        entities: { items: [] },
        entity: {},
        hospitalization: {},
        condition: {
          sort: "building,room,floor,no",
          asc: true,
          keyword: null,
          includePatient: true,
          pageSize: 100,
          pageIndexOnView: 1,
        },
        site: [],
      };
    },
    computed: {
      ...mapGetters(["dict", , "Enum", "dictEnum", "user", "permission", "setting"]),
      options() {
        let list = [];
        list.push(...this.dict.Building);
        list.push(...this.dict.Floor);
        list.push(...this.dict.Room);
        return this.$utils.Cascade.make(list);
      },
      searchFields() {
        return [
          { label: "病区", prop: "wardCode", type: "dict", options: this.dict.IpWard },
          { label: "科室", prop: "deptCode", type: "dict", options: this.dict.Dept },
          { label: "楼栋", prop: "building", type: "dict", options: this.dict.Building },
          { label: "楼层", prop: "floor", type: "dict", options: this.dict.Floor },
          { label: "病房", prop: "room", type: "dict", options: this.dict.Room },
          { label: "床位号", prop: "no", type: "input" },
          { label: "床位类型", prop: "type", type: "dict", options: this.dict.BedType },
          { label: "临时加床", prop: "ifExtra", type: "dict", options: this.$utils.Dict.bool() },
          { label: "停用状态", prop: "disabled", type: "dict", options: this.$utils.Dict.bool() },
          { label: "住院号", prop: "ipNo", type: "input" },
        ];
      },
    },
    mounted() {
      this.page();
      let model = this.$utils.Repository.get("nurse_bed_model");
      if (model != undefined) {
        this.meta.showCard = model;
      }
    },
    methods: {
      page() {
        this.condition.deptCode = this.user.deptCode;
        this.meta.loading = true;
        api.Bed.query(this.condition)
          .then((res) => {
            this.entities = res;
          })
          .catch((err) => {
            this.$message.error(err.message || err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      download() {
        api.Bed.export(this.condition, "住院床位.xls", [
          { property: "wardCode", title: "病区", dict: this.dict.IpWard },
          { property: "deptCode", title: "科室", dict: this.dict.Dept },
          { property: "building", title: "楼栋", dict: this.dict.Building },
          { property: "floor", title: "楼层", dict: this.dict.Floor },
          { property: "room", title: "病房", dict: this.dict.Room },
          { property: "no", title: "床位号" },
          { property: "type", title: "床位类型", dict: this.dict.BedType },
          { property: "ifExtra", title: "临时加床", dict: this.$utils.Dict.bool() },
          { property: "disabled", title: "停用状态", dict: this.$utils.Dict.bool() },
          { property: "ipNo", title: "患者住院号" },
        ]);
      },
      create() {
        this.entity = { deptCode: this.user.deptCode };
        this.meta.showEditor = true;
      },
      edit(row) {
        this.entity = this.$utils.Obj.clone(row);
        this.meta.showEditor = true;
      },
      del(row) {
        this.meta.loading = true;
        // api.delBed(this.entity.id)
        api.Bed.del(row.id)
          .then((res) => {
            this.$message.success("已删除！");
            this.page();
          })
          .catch((err) => {
            this.$message.error(err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      openBed(row) {
        this.hospitalization = row.hospitalization;
        this.meta.showBed = true;
      },
      //拖动相关
      dragstart(e, item) {
        //拖拽开始时将item存入vuex
        this.draging = item;
      },

      dragover(e) {
        //拖拽在这个div里面拖拽时执行的事件
        //一定要执行preventDefault(),否则drop事件不会被触发
        e.preventDefault();
      },
      drop(e, item) {
        //在div里拖拽停止时执行的事件
        if (item.disabled) {
          return this.$alert("此床位已停用！", "床位调整", { type: "error" });
        }
        let msg = `${this.draging.hospitalization.patientName} 将从【床位${this.draging.no}】 调整至【床位${item.no}】，确定要继续吗？`;
        if (item.ipNo) {
          if (this.draging.hospitalization.ipNo == item.ipNo) {
            return this.$alert("床位属于同一患者，无需调整！", "床位调整", { type: "error" });
          }

          msg = `${this.draging.hospitalization.patientName}【床位${this.draging.no}】 与 ${item.hospitalization.patientName}【床位${item.no}】 互相交换床位，确定要继续吗？`;
        }
        this.$confirm(msg, "床位调整", { type: "warning" })
          .then(() => {
            this.meta.loading = true;
            // api.delBed(this.entity.id)
            api.Bed.exchange(this.draging.id, item.id)
              .then((res) => {
                this.$message.success("床位已调整！");
                this.page();
              })
              .catch((err) => {
                this.$message.error(err);
              })
              .finally(() => {
                this.meta.loading = false;
              });
          })
          .catch((e) => {});
      },
      modelChange(model) {
        this.$utils.Repository.set("nurse_bed_model", model);
      },
      siteChange(site) {
        this.condition.building = site[0];
        this.condition.floor = site[1];
        this.condition.room = site[2];
        this.page();
      },
    },
  };
</script>
